<template>
  <div v-if="livingOption" class="living-option">    
    <main-content
      right-sidebar="true"
    >
      <img v-if="livingOption.logo" :src="$store.state.assetsPath + livingOption.logo" class="subsection__logo">
      <image-gallery 
        :autoplay="true" 
        :images="livingOption.images" 
        :show-nav="false"
      />

      <action-bar v-if="this.livingOption.propertyTypes[0] == 'apartment'">Select a floor</action-bar>
      <action-bar v-if="this.livingOption.propertyTypes[0] == 'lot'">Select a release</action-bar>
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="livingOption.sidebarMinimap"
      :heading="livingOption.label"
      :description="livingOption.description"
      :navigation-items="navigationItems"
    >
      <template slot="bottom-slot">
        <router-link tag="button" class="right-sidebar__back" to="/live"><fa icon="chevron-left"/>Back</router-link>
        <div class="right-sidebar__search"></div>
        <!-- <button class="right-sidebar__search"><fa icon="search"/>Search</button> -->
      </template>
    </right-sidebar>
  </div>  
</template>
<script>
import ActionBar from '@/components/ActionBar'
import AvailabilityMarker from '@/components/AvailabilityMarker'
import ImageGallery from '@/components/ImageGallery'
import MainContent from '@/components/MainContent'
import PropertyFilter from '@/components/PropertyFilter'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters } from 'vuex'
export default {
  components: { ActionBar, AvailabilityMarker, ImageGallery, MainContent, PropertyFilter, RightSidebar },
  computed: {
    ...mapGetters ({
      livingOption: 'property/activeLivingOption'
    }),

    navigationItems () {
      return this.livingOption.subsections.map(subsection => {
        return {
          label: subsection.displayName,
          to: `/live/${this.livingOption._id}/subsection/${subsection._id}`
        }
      })
    }
  }
}
</script>
<style lang="scss">
.living-option {
  &__logo {
    position: absolute;
    top: 3rem;
    right: 4rem;
    z-index: 999;
    max-height: 10rem;
  }
}
</style>